"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetDevicesByPdid = exports.useGetDeviceByPdid = void 0;
require("core-js/modules/es.json.stringify.js");
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/selectors");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const useGetDeviceByPdid = _ref => {
  let {
    thingPDIDDevice = null
  } = _ref;
  const device = ((0, _reactRedux.useSelector)(_selectors.selectDevicesById) || {})[thingPDIDDevice] || null;
  return (0, _react.useMemo)(() => device, [JSON.stringify(device)]);
};
exports.useGetDeviceByPdid = useGetDeviceByPdid;
const useGetDevicesByPdid = function useGetDevicesByPdid() {
  let thingPDIDDeviceList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return (0, _reactRedux.useSelector)((0, _selectors.selectDevicesByPdid)(thingPDIDDeviceList)) || [];
};
exports.useGetDevicesByPdid = useGetDevicesByPdid;